import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const FaqSection = () => {
    // State to manage which question is open
    const [openQuestion, setOpenQuestion] = useState(null);

    // Refs to manage the animation targets
    const answerRefs = useRef([]);
    answerRefs.current = [];

    // Function to add refs
    const addToRefs = (el) => {
        if (el && !answerRefs.current.includes(el)) {
            answerRefs.current.push(el);
        }
    };

    // Function to toggle the question
    const toggleQuestion = (question) => {
        setOpenQuestion(openQuestion === question ? null : question);
    };

    useEffect(() => {
        answerRefs.current.forEach((ref, index) => {
            if (openQuestion === index) {
                gsap.to(ref, { height: 'auto', opacity: 1, duration: 0.5 });
            } else {
                gsap.to(ref, { height: 0, opacity: 0, duration: 0.5 });
            }
        });
    }, [openQuestion]);

    // FAQ data
    const faqs = [
        { question: "What services do you offer?", answer: "We offer a comprehensive range of health and fitness services, including personalized workout plans, nutritional guidance, one-on-one coaching, group fitness classes, and wellness workshops." },
        { question: "How do I choose the right fitness program for me?", answer: "We offer a comprehensive range of health and fitness services, including personalized workout plans, nutritional guidance, one-on-one coaching, group fitness classes, and wellness workshops." },
        { question: "Can I track my progress with your programs?", answer: "We offer a comprehensive range of health and fitness services, including personalized workout plans, nutritional guidance, one-on-one coaching, group fitness classes, and wellness workshops." },
        { question: "What measures are in place to ensure safety during workouts?", answer: "We offer a comprehensive range of health and fitness services, including personalized workout plans, nutritional guidance, one-on-one coaching, group fitness classes, and wellness workshops." },
        { question: "What exercises can I do at home to complement my treatment?", answer: "We offer a comprehensive range of health and fitness services, including personalized workout plans, nutritional guidance, one-on-one coaching, group fitness classes, and wellness workshops." },
        { question: "How can I book an appointment?", answer: "We offer a comprehensive range of health and fitness services, including personalized workout plans, nutritional guidance, one-on-one coaching, group fitness classes, and wellness workshops." },
    ];

    return (
        <div className="flex flex-col items-center gap-[64px] sm:px-[7.7vw] sm:py-[96px] py-[48px] px-[24px] max-w-[1980px] w-full">

            <div className="flex flex-col items-center gap-[20px]">
                <h3 className='text-[#101828] sm:text-[36px] text-[32px] font-[600] text-center'>
                    Frequently asked questions
                </h3>
                <span className='text-[#475467] sm:text-[20px] text-[16px] text-center'>
                    Everything you need to know about the product and billing.
                </span>
            </div>

            <div className="flex flex-col md:w-[768px] gap-[32px] w-full">
                {faqs.map((faq, index) => (
                    <div key={index} className="flex flex-col items-start mb-[16px] w-full">
                        <div className="flex items-start justify-between gap-[24px] w-full cursor-pointer" onClick={() => toggleQuestion(index)}>
                            <div className="flex flex-col gap-[8px]">
                                <h4 className='text-[#101828] font-[500] sm:text-[18px] text-[16px]'>
                                    {faq.question}
                                </h4>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" className='min-w-[32px]'>
                                <path d={openQuestion === index ? "M8 12H16" : "M12 8V16M8 12H16"} stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div ref={addToRefs} style={{ height: 0, overflow: 'hidden', opacity: 0 }}>
                            <p className='text-[#475467] mt-[8px]'>
                                {faq.answer}
                            </p>
                        </div>
                        <hr className='border-[#EAECF0]' />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FaqSection;
